import Part from "../../part";

export default class Entrees extends Part {

  constructor(section) {
    super(section);

  }

  get options() {
    return {

      'simple': {
        price: 16,
        description: `Your choice of one menu package with one protein such as: Piri Piri Chicken, served with buttered rice, roasted carrots, fresh green salad, Zingerman’s Bakehouse bread and Michigan farm butter.`,
      },
      'medium': {
        price: 24,
        description: `Choose two different protein selections for your guests, with side dishes. Some favorites include marinated flank steak with mashed potatoes and Chef Bill’s Tunisian Chicken with lemon couscous, seasonal vegetable, a tossed green salad, Zingerman’s Bakehouse bread, and Michigan farm butter.`,
      },
      'deluxe': {
        price: 32,
        description: `A more elaborate menu with three entree choices such as braised boneless short ribs, Michigan whitefish, lemon and thyme chicken, ratatouille, rosemary au gratin potatoes, bacon Brussels sprouts, grilled vegetable salad, Zingerman’s Bakehouse bread, and Michigan farm butter.`,
      },
      'none': {
        price: 0,
      },
    };
  }

}



// WEBPACK FOOTER //
// ./scripts/catcalc/sections/food/entrees.js